<template>
  <div>
    <div style="margin: 0 40px;height: 32px"><el-button size="small" style="float: right;" type="primary" plain icon="el-icon-plus" @click="addSubOpen()">添加护理项目</el-button></div>
    <el-form style="margin: 10px 40px 0 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="类别名称" prop="sName">
            <el-input v-model="addEditForm.sName" placeholder="请输入类别名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="height: 350px;margin-left: 20px;padding-bottom: 20px">
        <el-table :data="subTableData" style="width: 100%" height="100%">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="subItemName"
            label="护理项目名称"
            min-width="80"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="editSubOpen(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="delSubOpen(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <div style="height: 50px">
      <el-row v-if="openType !== 0" style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
      <el-row v-else style="margin: 0 20px">
        <div class="cancel-btn" style="float: right" @click="closeAddEdit()">
          <span>关闭</span>
        </div>
      </el-row>
    </div>
    <el-dialog width="600px" :title="subTitleName" :visible.sync="addEditSubShow" v-if="addEditSubShow" append-to-body center>
      <el-form size="small" style="margin-right: 30px" :model="addEditSubForm" :rules="addEditSubRules" ref="addEditSubForm" label-width="140px" class="demo-ruleForm">
        <el-form-item label="护理项目名称" prop="subItemName">
          <el-input v-model="addEditSubForm.subItemName" placeholder="请输入护理项目名称"></el-input>
        </el-form-item>
      </el-form>
      <div style="margin-top: 30px;height: 50px">
        <el-row style="margin: 0 20px">
          <el-col :span="12">
            <div class="cancel-btn" @click="closeAddEditSub()">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitAddEditSub('addEditSubForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {updateeservice} from '../../../api/yanglaoyuan/eservice'

export default {
  name: 'addEditServiceProject',
  model: {
    prop: 'serviceProjectShow',
    event: 'change'
  },
  props: {
    serviceProjectObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      eId: 0,
      // 打开类型 0查看 1新增 2编辑
      openType: 0,
      row: '',

      addEditForm: {
        sName: ''
      },
      addEditRules: {
        sName: [{ required: true, message: '请输入类别名称', trigger: 'blur' }]
      },

      subTableData: [],
      subTitleName: '',
      subItemObj: {
        openType: 0,
        row: ''
      },
      addEditSubShow: false,
      addEditSubForm: {
        subItemName: ''
      },
      addEditSubRules: {
        subItemName: [{ required: true, message: '请输入护理项目名称', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      let that = this
      let loginResp = this.$store.state.user.LoginResp
      this.eId = loginResp.entity_id

      this.openType = this.serviceProjectObj.openType
      this.row = this.serviceProjectObj.row

      if (this.openType === 2) {
        this.addEditForm.sName = this.row.s_name
        if (this.row.sub_items && this.row.sub_items !== '' && this.row.sub_items.length !== 0) {
          this.row.sub_items.split('|').forEach((subItem, index) => {
            let obj = {
              subItemName: subItem,
              subItemId: index
            }
            that.subTableData.push(obj)
          })
        }
      }
    },

    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.openType === 1) {
            this.sendAdd()
          } else if (this.openType === 2) {
            this.sendEdit()
          }
        }
      })
    },
    sendAdd () {
      let subItems = ''
      this.subTableData.forEach(item => {
        if (subItems.length !== 0) {
          subItems += '|'
        }
        subItems += item.subItemName
      })
      let data = {
        oper_type: 0,
        eid: this.eId,
        s_name: this.addEditForm.sName,
        sub_items: subItems
      }
      updateeservice(data).then(res => {
        this.$notify({title: '成功', message: '成功新增该护理类别', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },
    sendEdit () {
      let subItems = ''
      this.subTableData.forEach(item => {
        if (subItems.length !== 0) {
          subItems += '|'
        }
        subItems += item.subItemName
      })
      let data = {
        oper_type: 1,
        eid: this.eId,
        s_id: this.row.s_id,
        s_name: this.addEditForm.sName,
        sub_items: subItems
      }
      updateeservice(data).then(res => {
        this.$notify({title: '成功', message: '成功修改该护理类别', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },
    closeAddEditSub () {
      this.addEditSubShow = false
    },
    submitAddEditSub (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.subItemObj.openType === 1) {
            this.sendSubAdd()
          } else if (this.subItemObj.openType === 2) {
            this.sendSubEdit()
          }
        }
      })
    },
    sendSubAdd () {
      let obj = {
        subItemName: this.addEditSubForm.subItemName,
        subItemId: this.subTableData.length
      }
      this.subTableData.push(obj)
      this.addEditSubShow = false
    },
    sendSubEdit () {
      let obj = this.subTableData.find(r => r.subItemId === this.subItemObj.row.subItemId)
      if (obj) {
        obj.subItemName = this.addEditSubForm.subItemName
      }
      this.addEditSubShow = false
    },
    addSubOpen () {
      this.subTitleName = '添加护理项目'
      this.subItemObj.openType = 1
      this.subItemObj.row = ''
      this.addEditSubForm.subItemName = ''
      this.addEditSubShow = true
    },
    editSubOpen (row) {
      this.subTitleName = '修改护理项目'
      this.subItemObj.openType = 2
      this.subItemObj.row = row
      this.addEditSubForm.subItemName = row.subItemName
      this.addEditSubShow = true
    },
    delSubOpen (row) {
      this.$confirm('此操作将删除该护理项目 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.subTableData.remove(row)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditServiceProject.vue